import { Injectable } from '@angular/core';
import { MenuItems } from 'src/app/administracion/menuItems';
import { NetsolinService } from './netsolin.service';

@Injectable({
  providedIn: 'root'
})
export class ErpService {

  modulos = {};
  loaded = false;
  constructor(private netsolinService: NetsolinService) {
    console.log('ERP Service');

    this.cargarModulosNetsolin(); //Inicializa el menu Predefinido ERP, Usuario ...
  }
  // initMenuPredefinido() {
  //   console.log('Inicializar menu netsolin -> ', this.modulos);
  //   var erp = new MenuItems(); //Item General.
  //   erp.component = 'admin';
  //   erp.icon = 'slack';
  //   erp.order = '0';
  //   erp.path = ''
  //   erp.permission = ['admin'];
  //   erp.title = "ERP";
  //   erp.type = 'sub';
  //   var itemsErp = [];
  //   var ordcount = 0;
  //   //Apartado para construir los apartados generales Mantenimiento, Procesos, Consultas
  //   var mantablas = new MenuItems(); //Sub Item General.
  //   var procesos = new MenuItems(); //Sub Item General.
  //   //MANTENIMIENTO
  //   mantablas.component = 'admin';
  //   mantablas.icon = 'box';
  //   mantablas.order = '0';
  //   mantablas.path = ''
  //   mantablas.permission = ['admin'];
  //   mantablas.title = "Mantenimiento";
  //   mantablas.type = 'sub';
  //   //PROCESOS
  //   procesos.component = 'admin';
  //   procesos.icon = 'crosshair';
  //   procesos.order = '1';
  //   procesos.path = ''
  //   procesos.permission = ['admin'];
  //   procesos.title = "Procesos";
  //   procesos.type = 'sub';
  //   for (let modulo of this.modulos) {
  //     var itemEstr = new MenuItems(); //Estructura para Sub Items.
  //     var itemsSubmodulo = [];
  //     itemEstr.path = 'erp/' + modulo.nom_obj;
  //     itemEstr.icon = '';
  //     itemEstr.order = '' + ordcount + '';
  //     itemEstr.permission = ['admin'];
  //     itemEstr.title = modulo.nom_obj;
  //     itemEstr.type = 'sub';
  //     for (let submodulo of modulo.submodulos) {
  //       var itemSubEstr = new MenuItems(); //Estructrua para Childres de Sub Items.
  //       itemSubEstr.path = 'erp/' + modulo.cod_obj + '/' + submodulo.nom_obj;
  //       itemSubEstr.icon = '';
  //       itemSubEstr.order = '' + ordcount + '';
  //       itemSubEstr.permission = ['admin'];
  //       itemSubEstr.title = submodulo.nom_obj;
  //       itemSubEstr.type = 'link';
  //       if (submodulo.pvistForm.form_auto === "V") {
  //         itemSubEstr.path = '/manobjbasinetsolin/' + modulo.cod_obj + '/' + submodulo.pvistForm.nom_tabla;
  //       }
  //       if (submodulo.nom_obj == 'Clientes') {
  //         itemSubEstr.path = 'erp/' + modulo.cod_obj + '/' + 'ClieProTerceros';
  //       }
  //       itemsSubmodulo.push({ ...itemSubEstr });
  //     }
  //     itemEstr.children = itemsSubmodulo;
  //     itemsErp.push({ ...itemEstr });
  //     ordcount++;
  //   }
  //   //Items de mantenimiento de tablas
  //   mantablas.children = itemsErp;
  //   //Items erp
  //   erp.children = [mantablas, procesos];
  //   console.log('item Menu ERP->', erp);
  // }


  async cargarModulosNetsolin() {
    console.log('Init Menu Predefinido');
    this.netsolinService.getModulosNetsolin().then(async (data: any) => {
      console.log('Modulos -> ', data);
      var promises = []
      var modulos = {}
      data.modulos.forEach(modulo => {
        modulos[modulo.cod_obj] = modulo;
        modulos[modulo.cod_obj]['modulos'] = {};
        let p = this.netsolinService.getSubModuloNetsolin(parseInt(modulo.cod_obj)).then((res: any) => {
          console.log('res:',res);
          res.mantablas.forEach(subm => {
            subm.modulo = modulo.cod_obj
            var pvistsplit = subm.pvist.split('\r\n'); //Separa PVIST de STRING a arreglo por salto de linea
            // console.log('pvist split string',pvistsplit);
            var pvistForm = {}; //Crea un objeto vacio de el PVIST formateado
            for (let pviststr of pvistsplit) { //Recorre arreglo de PVIST por linea
              var pvistrsplit = pviststr.split('='); //Separa PVIST por el simbolo =
              pvistForm[pvistrsplit[0]] = pvistrsplit[1]; //Llena Objeto vacio donde la llave de el objeto es la posicion 0 y el valor la posicion 1
            }
            subm['pvistForm'] = pvistForm
            modulos[modulo.cod_obj]['modulos'][subm.cod_obj] = subm;
            // modulos[modulo.cod_obj]['modulos'][subm.cod_obj].icon = `/assets/svg/${subm.image ? subm.image : 'drawing-tablet'}.svg`;
            modulos[modulo.cod_obj]['modulos'][subm.cod_obj].icon = `/assets/svg/drawing-tablet.svg`;
            modulos[modulo.cod_obj]['modulos'][subm.cod_obj].per = subm['ctipo_obj'].includes('U');
            modulos[modulo.cod_obj]['modulos'][subm.cod_obj].path = modulo.cod_obj + '/' + subm.cod_obj;
            if (subm.pvistForm.form_auto === "V") {
              modulos[modulo.cod_obj]['modulos'][subm.cod_obj].path = '/manobjbasinetsolin/' + modulo.cod_obj + '/' + subm.cod_obj;
            }
            if (subm.nom_obj == 'Clientes') {
              modulos[modulo.cod_obj]['modulos'][subm.cod_obj].path = modulo.cod_obj + '/' + 'ClieProTerceros';
            }
          });
        })
        promises.push(p);
      });
      await Promise.all(promises).then((respromises: any) => {
        this.modulos = modulos;
        console.log("Carga de modulos lista", modulos)
        this.netsolinService.modulos = this.modulos;
        this.loaded = true;
      });
    });

  }

}
